import { useLocale } from '../i18n/LocaleContext';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const { t, path, appLink } = useLocale();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Nav>
      <NavContainer>
        <LogoContainer>
          <Link to={path("/")}>
            <LogoWrapper>
              <LogoImg
                src={process.env.PUBLIC_URL + '/noteician_logo_no_text.png'}
                alt="Noteician Logo"
              />
              <LogoText>Noteician</LogoText>
            </LogoWrapper>
          </Link>
        </LogoContainer>

        <NavMenu $isOpen={isOpen}>
          <NavItem>
            <NavLink to={path("/")}>{t('nav.home')}</NavLink>
          </NavItem>
          <NavItem>
            <NavLink to={path("/how-to-use")}>{t('nav.how')}</NavLink>
          </NavItem>
          <NavItem>
            <NavLink to={path("/pricing")}>{t('nav.pricing')}</NavLink>
          </NavItem>
          <NavItem>
            <NavLink to={path("/contact")}>{t('nav.contact')}</NavLink>
          </NavItem>
          <NavItem>
            <AppButton href={appLink()} target="_blank" rel="noopener noreferrer">
              {t('common.start')}
            </AppButton>
          </NavItem>
        </NavMenu>
        <NavActions>
          <LanguageSwitcher />
          <MenuToggle aria-label={t("nav.menu")} aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)}>
            <span></span><span></span><span></span>
          </MenuToggle>
        </NavActions>
      </NavContainer>
    </Nav>
  );
};

const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--white);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 15px 0;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  gap: 16px;
  @media (max-width: 480px) { padding: 0 12px; gap: 8px; }
`;

const NavActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  @media (max-width: 480px) { gap: 8px; }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MenuToggle = styled.button`
  border: 0; background: none;
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    height: 2px;
    width: 25px;
    background: var(--primary);
    margin-bottom: 4px;
    border-radius: 5px;
  }

  @media (max-width: 1100px) {
    display: flex;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;

  @media (max-width: 1100px) {
    flex-direction: column;
    position: absolute;
    top: 100%;
    inset-inline-start: 0;
    width: 100%;
    background: var(--white);
    padding: 20px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);
    transition: var(--transition);
    opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
    visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
    transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(-20px)')};
  }
`;

const NavItem = styled.li`
  margin-inline-start: 20px;

  @media (max-width: 1100px) {
    margin: 10px 0;
    width: 100%;
    text-align: center;
  }
`;

const NavLink = styled(Link)`
  color: var(--dark-gray);
  font-weight: 500;
  transition: var(--transition);

  &:hover {
    color: var(--primary);
  }
`;

const AppButton = styled.a`
  display: inline-block;
  padding: 8px 16px;
  background: var(--gradient);
  color: white !important;
  border-radius: 8px;
  font-weight: 600;
  transition: var(--transition);

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow);
  }

  @media (max-width: 1100px) {
    width: 100%;
    text-align: center;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const LogoImg = styled.img`
  height: 32px;   /* adjust size if needed */
  width: auto;
  margin-inline-end: 10px;
  @media (max-width: 480px) { height: 28px; margin-inline-end: 6px; }
`;

const LogoText = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary);
  margin: 0;
  @media (max-width: 480px) { font-size: 1.15rem; }
`;


export default Navbar;
